function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V14C20 15.1046 19.1046 16 18 16H2C0.895431 16 0 15.1046 0 14V2Z",
  fill: "#84DBD6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.505 10.19C10.89 10.19 10.295 10.09 9.74 9.91C9.565 9.85 9.37 9.895 9.235 10.03L8.45 11.015C7.035 10.34 5.71 9.065 5.005 7.6L5.98 6.77C6.115 6.63 6.155 6.435 6.1 6.26C5.915 5.705 5.82 5.11 5.82 4.495C5.82 4.225 5.595 4 5.325 4H3.595C3.325 4 3 4.12 3 4.495C3 9.14 6.865 13 11.505 13C11.86 13 12 12.685 12 12.41V10.685C12 10.415 11.775 10.19 11.505 10.19Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 2C11.4545 2 9.70773 3.27227 9 5.06818C9.70773 6.86409 11.4545 8.13636 13.5 8.13636C15.5455 8.13636 17.2923 6.86409 18 5.06818C17.2923 3.27227 15.5455 2 13.5 2ZM13.5 7.11364C12.3709 7.11364 11.4545 6.19727 11.4545 5.06818C11.4545 3.93909 12.3709 3.02273 13.5 3.02273C14.6291 3.02273 15.5455 3.93909 15.5455 5.06818C15.5455 6.19727 14.6291 7.11364 13.5 7.11364ZM13.5 3.84091C12.8209 3.84091 12.2727 4.38909 12.2727 5.06818C12.2727 5.74727 12.8209 6.29545 13.5 6.29545C14.1791 6.29545 14.7273 5.74727 14.7273 5.06818C14.7273 4.38909 14.1791 3.84091 13.5 3.84091Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 12,
  r: 2.5,
  fill: "#F5841F",
  stroke: "white"
});

function SvgCallProcessingRedDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallProcessingRedDot);
export default __webpack_public_path__ + "static/media/call_processing_red_dot.501ab7a5.svg";
export { ForwardRef as ReactComponent };